import { memo } from 'react'
import { View } from 'react-native'
import styled from 'styled-components'
import FeaturedActorCard from './FeaturedActorCard'

const List = styled(View)`
  flex-direction: row;
  margin-top: ${(props) => props.theme.spacing.xs}px;
  height: 50%;
`

const FeaturedActorList = memo(
  ({ actors = [], onActorSelect }) =>
    actors.length > 0 && (
      <List>
        {actors.slice(0, 2).map(({ posterImg, ...actorProps }) => (
          <FeaturedActorCard
            {...actorProps}
            key={actorProps.slug}
            publicId={posterImg}
            onActorSelect={onActorSelect}
          />
        ))}
      </List>
    ),
)

export default FeaturedActorList
